import { render } from "./SectionTravel.vue?vue&type=template&id=36a5fd1c&scoped=true"
import script from "./SectionTravel.vue?vue&type=script&lang=js"
export * from "./SectionTravel.vue?vue&type=script&lang=js"

import "./SectionTravel.vue?vue&type=style&index=0&id=36a5fd1c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a5fd1c"]])

export default __exports__